export const institutionsRouter = [
    {
        path: 'enrollments',
        name: 'Enrollment',
        component: () => import('./pages/enrollment/Index'),
    },
    {
        path: 'enrollments/new',
        name: 'New Enrollment',
        component: () => import('./pages/enrollment/Enrollment'),
    },
    {
        path: 'enrollments/:id',
        name: 'View Enrollment',
        component: () => import('./pages/enrollment/EnrollmentView'),
    },
    {
        path: 'enrollments/approve/:id',
        name: 'View Enrollment approve',
        component: () => import('./pages/enrollment/EnrollmentView'),
    }
]